<div class="search-autocomplete" [class.disabled]="disabled">
    <input class="search-autocomplete__input"
           type="text"
           [disabled]="disabled"
           [placeholder]="placeholder"
           [value]="inputValue"
           (input)="onInput($any($event.target).value)"
           (focus)="onFocus()">

    <div class="search-autocomplete__panel" *ngIf="shouldShowPanel">
        <button type="button"
                class="search-autocomplete__item"
                *ngFor="let item of items; trackBy: trackByItem"
                (click)="onSelect(item)">
            {{ item[displayField] }}
        </button>
    </div>
</div>
